import { connect } from "react-redux";
import { withFormik } from "formik";
import { ownerPortfoliosSelector, selectedPortfolioSelector } from "selectors/portfolio";

import withMaps from "components/hoc/withMaps";

import AssetCreateForm from "./AssetCreateForm";
import validationSchema from "./validationSchema";

const form = withFormik({
  displayName: "asset",
  enableReinitialize: true,
  mapPropsToValues: ({ currentUser, selectedPortfolio }) => ({
    autogenerateFlyer: true,
    pointPerson: {
      id: currentUser.id,
    },
    status: "invite",
    portfolio: selectedPortfolio,
  }),
  handleSubmit: async (values, { props: { geocode, onSubmit }, setSubmitting }) => {
    const address = `${values.address}, ${values.zip} ${values.city}, ${values.country.name}`;

    try {
      const [lat, lng] = await geocode(address);

      return onSubmit({ ...values, lat, lng }).finally(() => setSubmitting(false));
    } catch (_) {
      return onSubmit({ ...values }).finally(() => setSubmitting(false));
    }
  },
  validationSchema: () => validationSchema,
})(AssetCreateForm);

const mapStateToProps = (state) => ({
  currentUser: state.currentUser,
  isSubmitting: state.loading.asset,
  portfolios: ownerPortfoliosSelector(state),
  selectedPortfolio: selectedPortfolioSelector(state),
});

export default withMaps(connect(mapStateToProps)(form));
